function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#F8F8F8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 32C19.866 32 23 28.866 23 25C23 21.134 19.866 18 16 18C12.134 18 9 21.134 9 25C9 28.866 12.134 32 16 32Z",
  fill: "#0063DB"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34 32C37.866 32 41 28.866 41 25C41 21.134 37.866 18 34 18C30.134 18 27 21.134 27 25C27 28.866 30.134 32 34 32Z",
  fill: "#FF0084"
});

var SvgSourceFlickr = function SvgSourceFlickr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceFlickr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_flickr.3a44f25e.svg";
export { ForwardRef as ReactComponent };